export default {
    init() {
        var secondary = $('.gallery-container .gallery');
        if (secondary.find('.padder > div').length) {
            var prevArrow = $('<button />').addClass('gallery-prev').html('Previous');
            var nextArrow = $('<button />').addClass('gallery-next').html('Next');
            secondary.find('.padder').slick({
                appendDots: secondary,
                dots: true,
                dotsClass: 'gallery-dots',
                infinite: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 1369,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            });

            secondary.append(prevArrow).append(nextArrow);

            var gallery_images = $('.gallery-image');
            if (gallery_images.length) {
                var image_links = gallery_images.find('a');
                image_links.hover(function () {
                    var link = $(this);
                    var primary_cont = link.closest('.gallery-container').find('.primary');
                    var primary = primary_cont.find('img');
                    var caption = primary_cont.find('.caption');
                    primary.attr('src', link.data('image'));
                    caption.html(link.find('img').data('description'));
                    link.closest('.gallery').find('.gallery-image').find('a').removeClass('active');
                    link.addClass('active');
                });

                var gallery = $('.gallery');

                gallery.magnificPopup({
                    delegate: '.slick-slide:not(.slick-cloned, .video) a', // the selector for gallery item
                    type: 'image',
                    image: {
                        titleSrc: function (item) {
                            return item.el.find('img').data('description');
                        },
                    },
                    gallery: {
                        enabled: true,
                    },
                });

                var primary = gallery.parent().find('.primary');
                if (primary.length) {
                    primary.find('.padder').click(function (e) {
                        e.preventDefault();
                        gallery.find('a.active').click();
                    });

                }
            }
        }

    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleGallery.js